import React from "react";
import useSessionDataPduli from "../../costumeHooks/useSessionDataPduli";

export default function KonselingInformationSession() {
  const { dataSessionPduli } = useSessionDataPduli({});
  console.log("dataSessionPduli", dataSessionPduli);
  return (
    <div className="bg-secondary-600 p-5 rounded-md">
      {/* <div>
        <h2 className="font-semibold  text-primary-500 text-sm">
          Kategori Konsultasi
        </h2>
        <p className="text-white">{dataSessionPduli?.voucher?.name}</p>
      </div> */}
      <div>
        <h2 className="font-semibold  text-primary-500 text-sm">
          Permasalahan Konseli
        </h2>
        <p className="text-white">{dataSessionPduli?.voucher?.problem}</p>
      </div>
    </div>
  );
}
